import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Dropdown from "../../components/Dropdown";
import {
  Container,
  Heading,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Stack,
  Radio,
  RadioGroup,
  Select,
  Button,
  useToast,
} from "@chakra-ui/react";

const API_BASE_URL = "https://qaapirgeneng.digitalfields.co.za/ws1.cfc";
const HCLIENT_ID = 14;

const NewRequest14 = () => {
  const HuserID = localStorage.getItem("HuserID");
  const UUID = localStorage.getItem("UUID");
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const [candidateName, setCandidateName] = useState("");
  const [batteries, setBatteries] = useState([]);
  const [opDepartments, setOpDepartments] = useState([]);
  const [hrbps, setHrbps] = useState([]);
  const [requestors, setRequestors] = useState([]);

  const [formData, setFormData] = useState({
    candidateID: Number(id),
    HbatteryID: "",
    opDepartment: "",
    hrbp: null,
    requestor: null,
    reqPurpose: "",
    sendEmailYN: null,
  });

  const [errors, setErrors] = useState({
    sendEmailYN: "",
  });

  const getCandidateDets = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getcandidateDets&huserID=${HuserID}&uuid=${UUID}&candidateID=${id}`,
        { method: "GET" }
      );
      const data = await response.json();
      const candidateDets = data[0].candidateDets[0];
      setCandidateName(candidateDets.fname + " " + candidateDets.sname);
    } catch (error) {
      toast({
        title: "Error fetching candidate details",
        description:
          "There was an error fetching the candidate. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getBatteriesPerClient = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getBatteriesPerClient&huserID=${HuserID}&uuid=${UUID}&HclientID=${HCLIENT_ID}`,
        { method: "GET" }
      );
      const data = await response.json();
      setBatteries(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
      toast({
        title: "Error fetching batteries",
        description: "There was an error loading batteries. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getDepartmentPerClient = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getDepartmentPerClient&huserID=${HuserID}&uuid=${UUID}&HclientID=${HCLIENT_ID}`,
        { method: "GET" }
      );
      const data = await response.json();
      setOpDepartments(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getHRBPPerClient = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getHRBPPerClient&huserID=${HuserID}&uuid=${UUID}&HclientID=${HCLIENT_ID}`,
        { method: "GET" }
      );
      const data = await response.json();
      setHrbps(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getRequestorsPerClient = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getRequestorsPerClient&huserID=${HuserID}&uuid=${UUID}&HclientID=${HCLIENT_ID}`,
        { method: "GET" }
      );
      const data = await response.json();
      setRequestors(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const postNewRequest = async () => {
    try {
      setLoading(true);
      return await fetch(
        `${API_BASE_URL}?method=addRequest14&huserID=${HuserID}&uuid=${UUID}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
          mode: "no-cors",
        }
      );
    } catch (error) {
      toast({
        title: "Error posting request details",
        description:
          "There was an error submitting your request. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      toast({
        title: "Request Submitted!",
        description: `Candidate ${candidateName} now has a request logged`,
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "HbatteryID" || name === "reqPurpose") {
      setFormData({
        ...formData,
        [name]: value,
      });
      return;
    }

    setFormData({
      ...formData,
      [name]: Number(value),
    });
  };

  const handleRadioChange = (name, value) => {
    const boolValue = value === "true";

    setFormData({
      ...formData,
      [name]: boolValue,
    });

    if (errors.sendEmailYN) {
      setErrors({
        ...errors,
        sendEmailYN: "",
      });
    }
  };

  const validateRadio = () => {
    const newErrors = {
      sendEmailYN: "",
    };

    let isValid = true;

    if (formData.sendEmailYN === null) {
      newErrors.sendEmailYN = "Please select an option";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.reqPurpose) {
      toast({
        title: "Request Purpose required",
        description: "Please select Recruitment or Development.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    if (!validateRadio()) {
      return;
    }

    postNewRequest();

    setFormData({
      candidateID: Number(id),
      HbatteryID: "",
      opDepartment: "",
      hrbp: null,
      requestor: null,
      reqPurpose: "",
      sendEmailYN: null,
    });
  };

  useEffect(() => {
    getCandidateDets();
    getBatteriesPerClient();
    getDepartmentPerClient();
    getHRBPPerClient();
    getRequestorsPerClient();
  }, []);

  return (
    <Container minW="80vw" p={5}>
      <Heading className="text-xl font-bold" mb="12">
        New Request for {candidateName}
      </Heading>

      <form onSubmit={handleSubmit}>
        <FormControl my={6} isRequired>
          <FormLabel fontWeight="bold">Select Battery</FormLabel>
          <Select
            name="HbatteryID"
            value={formData.HbatteryID}
            onChange={handleChange}
            placeholder="Select a battery"
            maxW="60ch"
            isDisabled={loading}
          >
            {batteries.map((battery) => (
              <option
                key={battery.HbatteryID || battery.allocRequestBatteryID}
                value={battery.HbatteryID}
              >
                {battery.Shortdescription || battery.shortdescription || battery.batteryName || battery.displayname}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl my={6}>
          <FormLabel fontWeight="bold">Operational Department</FormLabel>
          <Dropdown
            margin="2"
            width="60ch"
            placeHolder="Select Operational Department"
            name="opDepartment"
            options={opDepartments}
            optionKey="HdepartmentID"
            optionDisplay="shortdescription"
            state={formData}
            handleChange={handleChange}
            required={true}
          />
        </FormControl>

        <FormControl my={6}>
          <FormLabel fontWeight="bold">HRBP</FormLabel>
          <Dropdown
            margin="2"
            width="60ch"
            placeHolder="Select HRBP"
            name="hrbp"
            options={hrbps}
            optionKey="HuserID"
            optionDisplay="fname"
            state={formData}
            handleChange={handleChange}
            optionDisplayAdd="sname"
            required={true}
          />
        </FormControl>

        <FormControl my={6}>
          <FormLabel fontWeight="bold">Requestor</FormLabel>
          <Dropdown
            margin="2"
            width="60ch"
            placeHolder="Select Requestor"
            name="requestor"
            options={requestors}
            optionKey="HuserID"
            optionDisplay="fname"
            state={formData}
            handleChange={handleChange}
            optionDisplayAdd="sname"
            required={true}
          />
        </FormControl>

        <FormControl mt="8" isRequired>
          <FormLabel fontWeight="bold">Request Purpose</FormLabel>
          <RadioGroup value={formData.reqPurpose || ""}>
            <Stack direction="row">
              <Radio
                name="reqPurpose"
                value="recruitment"
                onChange={handleChange}
              >
                Recruitment
              </Radio>
              <Radio
                name="reqPurpose"
                value="development"
                onChange={handleChange}
              >
                Development
              </Radio>
            </Stack>
          </RadioGroup>
        </FormControl>

        <FormControl isInvalid={!!errors.sendEmailYN} mt="12">
          <FormLabel fontWeight="bold">Email Candidate Notification</FormLabel>
          <RadioGroup
            isRequired
            name="sendEmailYN"
            value={
              formData.sendEmailYN === null
                ? ""
                : formData.sendEmailYN.toString()
            }
            onChange={(value) => handleRadioChange("sendEmailYN", value)}
          >
            <Radio value="true" mr="8">
              Yes
            </Radio>
            <Radio value="false">No</Radio>
          </RadioGroup>
          <FormErrorMessage color="secondary2">
            {errors.sendEmailYN}
          </FormErrorMessage>
        </FormControl>

        <Button type="submit" my="12" isLoading={loading}>
          Submit
        </Button>
      </form>
    </Container>
  );
};

export default NewRequest14;
